import { jsx as _jsx } from "react/jsx-runtime";
import Field from "../Field/Field";
import Select from "./Select";
var InputSelect = function (_a) {
    var id = _a.id, displayName = _a.displayName, options = _a.options, defaultValue = _a.defaultValue, onChange = _a.onChange, error = _a.error, tip = _a.tip, after = _a.after, _b = _a.disabled, disabled = _b === void 0 ? false : _b, hideLabel = _a.hideLabel, reactHookForm = _a.reactHookForm;
    var inputEl = (_jsx(Select, { id: id, displayName: displayName, options: options, defaultValue: defaultValue, onChange: onChange, error: error !== undefined, disabled: disabled, reactHookForm: reactHookForm }));
    return (_jsx(Field, { inputEl: inputEl, id: id, displayName: displayName, error: error, tip: tip, after: after, exclamationPadding: "pr-10", hideLabel: hideLabel }));
};
export default InputSelect;
